import { AUTH_ENDPOINTS } from "@/shared/config/auth"
import { authClient } from "./auth-client"

interface RefreshResponse {
	accessToken: string
	expiresIn: string
}

export const refreshToken = async (): Promise<RefreshResponse> => {
	const { data } = await authClient.post<RefreshResponse>(AUTH_ENDPOINTS.REFRESH)
	return data
}
